export default __webpack_public_path__ + "static/media/image1-home7.22b1cae3.png";